import { render, staticRenderFns } from "./adverts-list-item-up.vue?vue&type=template&id=3aaa50c6"
import script from "./adverts-list-item-up.vue?vue&type=script&lang=ts"
export * from "./adverts-list-item-up.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports